<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">
                        <span class="ml-3">Transacciones realizadas</span>
                    </h4>
                    <div class="text-right mb-3">
                        <button class="btn btn-primary btn-sm btn__actualizar" @click="getTrans" :disabled="cargandoListado">
                            <i class="fa fa-refresh" :class="{ 'fa-spin': cargandoListado }"></i>
                        </button>
                    </div>
                    <div class="card m-b-30">
                        <div class="card-body">
                            <div class="searchResult">
                                <div class="row" v-if="transacciones.length > 0">
                                    <div v-for="item in transacciones.slice().reverse()" class="col-12 mb-2 resultItem">
                                        <div>
                                            <h6 class="font-weight-bold">Operación de pago No.00{{item.id}}</h6>
                                            <div v-if="item.tipo === 'deducible'">
                                                <b>Reclamo:</b> {{ item.reclamo }}
                                            </div>
                                            <div v-if="item.tipo === 'prima'">
                                                <b>Poliza:</b> {{ item.poliza }}, <b>Requerimiento:</b> {{ item.requerimiento }}
                                            </div>
                                            <div>
                                                <b>Fecha:</b> {{ dayjs(item.createdAt).format('DD-MM-YYYY') }}
                                            </div>
                                            <div>
                                                <b>Nombre:</b> {{ item.nombreAsegurado }}
                                            </div>
                                            <div>
                                                <b>Monto:</b> {{item.moneda}} {{ Numbro((item.monto) ? item.monto : 0).format({ thousandSeparated: true, mantissa: 2 }) }}
                                            </div>
                                            <div>
                                                <b>Estado: </b>
                                                <span v-if="item.estado === 'iniciado'">Iniciado sin completar</span>
                                                <span v-else-if="item.estado === 'fallido'">Fallido</span>
                                                <span v-else-if="item.estado === 'pagado'">Pagado sin presentar en ACSEL</span>
                                                <span v-else-if="item.estado === 'iniciado_pagado'" class="text-warning">Pagado en tarjeta, pendiente aplicar en ACSEL</span>
                                                <span v-else-if="item.estado === 'pagado_presentado'">Pagado y presentado</span>
                                                <span v-if="item.fechaReversa" class="text-danger"> - Marcado para anular</span>
                                            </div>
                                            <div>
                                                <b>Mensaje:</b> {{ item.estadoDescripcion }}
                                            </div>
                                        </div>

                                        <div v-if="typeof item.pagos !== 'undefined' && Object.keys(item.pagos).length > 0" style="background: #f8f8f8;" class="p-2">
                                            <div v-for="itemPago in item.pagos" class="mb-2">
                                                <b>- Pago: </b>
                                                <span v-if="itemPago.type === 'EFE'">Efectivo, monto {{itemPago.monto}}</span>
                                                <span v-if="itemPago.type === 'TAR'">Tarjeta, Autorización.{{itemPago.auth}}, monto {{itemPago.monto}}</span>
                                                <span v-if="itemPago.type === 'CHQ'">Cheque No.{{itemPago.noCheque}}, monto {{itemPago.monto}}</span>
                                                <span v-if="itemPago.fechaReversa" class="text-danger"> (Anulado)</span>
                                                <div class="text-center mt-2">
                                                    <button v-if="!isOnApp && !itemPago.fechaReversa" class="btn btn-sm btn-danger mx-1 btn__anular" @click="revertirEpay(itemPago)">Anular</button>
                                                    <button v-if="isOnApp && !itemPago.fechaReversa" @click="anularPos(itemPago)" class="btn btn-sm btn-danger mx-1 btn__anularTransaccion">Anular Transacción</button>
                                                    <button v-if="!isOnApp && parseInt(itemPago.fromPOS) === 0 && item.estado === 'pagado_presentado' && itemPago.type === 'TAR' && !itemPago.fechaReversa" @click="printVoucherPdf(itemPago)" class="btn btn-sm btn-success mx-1b btn__imprimir">Imprimir Voucher PDF</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="text-center mt-2 pagoBtn">
                                            <!--<button v-if="item.estado === 'pagado_presentado' && item.type === 'TAR'" @click="printVoucher(item.dataResponse)" class="btn btn-sm btn-success">Imprimir Voucher</button>-->
                                            <button v-if="isOnApp && item.facturaUno && item.estado === 'pagado_presentado' && !item.fechaReversa" @click="printInvoiceOne(item)" class="btn btn-sm btn-info mb-1 btn__imprimirFactura">Imprimir factura</button>
                                            <button v-if="isOnApp && item.facturaDos && item.estado === 'pagado_presentado' && !item.fechaReversa" @click="printInvoiceTwo(item)" class="btn btn-sm btn-info ml-1 mb-1 btn__imprimirFacturaDep">Imprimir factura dep</button>
                                            <button v-if="isOnApp && item.recibo && item.estado === 'pagado_presentado' && !item.fechaReversa" @click="printRecibo(item)" class="btn btn-sm btn-info ml-1 mb-1 btn__imprimirRecibo">Imprimir recibo</button>
                                            <!--<button v-if="isOnApp && parseInt(item.fromPOS) === 1 && item.type === 'TAR' && !item.fechaReversa" @click="anularPos(item)" class="btn btn-sm btn-danger">Anular</button>-->
                                            <!--<button v-if="!isOnApp && parseInt(item.fromPOS) === 0 && (item.estado === 'pagado_presentado' || item.estado === 'pagado' || item.estado === 'fallido') && item.type === 'TAR' && !item.fechaReversa" @click="revertirEpay(item)" class="btn btn-sm btn-danger">Revertir transacción</button>-->
                                            <button v-if="!isOnApp && item.facturaUno && item.estado === 'pagado_presentado' && !item.fechaReversa" @click="printInvoicePdf(item)" class="btn btn-sm btn-info ml-1 mb-1 btn__imprimirFactura">Imprimir factura</button>
                                            <button v-if="!isOnApp && item.facturaDos && item.estado === 'pagado_presentado' && !item.fechaReversa" @click="printInvoiceTwoPdf(item)" class="btn btn-sm btn-info ml-1 mb-1 btn__imprimirFacturaDep">Imprimir factura dep</button>
                                            <button v-if="!isOnApp && item.recibo && item.estado === 'pagado_presentado' && !item.fechaReversa" @click="printReciboPdf(item)" class="btn btn-sm btn-info ml-1 mb-1 btn__imprimirRecibo">Imprimir recibo PDF</button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="text-center text-muted">
                                    No se encontraron transacciones
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import AndroidBridge from "src/core/AndroidBridge";
import {CONFIG} from "src/config";

export default {
    props: [],
    components: {
        Pago,
        Layout,
    },
    data() {
        return {
            isOnApp: false,
            androidBridge: false,
            transacciones: [],
            anulando: {},
            cargandoListado: false,
        };
    },
    computed: {
    },
    mounted() {
        const self = this;
        this.androidBridge = new AndroidBridge();
        this.isOnApp = this.androidBridge.appEnabled();
        this.getTrans();

        //console.log('******** CONFIGURANDO LISTENER WINDOW *********');
        window.addEventListener('AndroidBridgeVisanetPayAppAnular', function (e) {
            console.log('**** AndroidBridgeVisanetPayAppAnular event ****');
            console.log(e);
            if (typeof e.detail !== 'undefined') {
                if (parseInt(e.detail.status) === 0) {
                    alert(e.detail.msg);
                }
                else {
                    API.send('POST', 'cobros/anular', {
                            id: self.anulando.id
                        },
                        function (response) {
                            console.log(response);
                            store.dispatch('coreHideLoading');
                            self.getTrans();
                        },
                        function () {
                            alert('Error de conexión, por favor intente de nuevo');
                        });
                }
            }
            else {
                self.pagoTarjetaResult = "Error al abrir App Visanet";
                self.cancelarPagoPos();
            }
        });
    },
    methods: {
        Numbro,
        dayjs,
        getTrans() {
            const self = this;

            if (self.cargandoListado) {
                return;
            }

            self.cargandoListado = true;

            API.send('GET', 'consulta/listado-pagos', null,
                function (response) {
                    if (response.status) {
                        const tmpObject = (typeof response.data === "object") ? response.data : {};
                        self.transacciones = Object.keys(tmpObject).map((key) => tmpObject[key]);
                        console.log(self.transacciones);
                    }
                    else {
                        alert(response.msg);
                    }
                    self.cargandoListado = false;
                },
                function () {
                    self.cargandoListado = false;
                    alert('Error de conexión, por favor intente de nuevo');
                });
        },
        printVoucher(info) {
            const obj = JSON.parse(info);
            if (typeof obj.voucher !== 'undefined') {
                const infoTmp = JSON.stringify(obj.voucher);
                this.androidBridge.PrintVoucher(infoTmp);
            }
        },
        printInvoiceOne(info) {

            const self = this;

            if (typeof info.facturaUno !== 'undefined') {
                const infoTmp = JSON.stringify(info.facturaUno);
                console.log(infoTmp);
                self.androidBridge.PrintFactura(infoTmp);
            }
        },
        printInvoiceTwo(info) {

            const self = this;

            if (typeof info.facturaDos !== 'undefined') {
                const infoTmp = JSON.stringify(info.facturaDos);
                console.log(infoTmp);
                self.androidBridge.PrintFactura(infoTmp);
            }
        },
        printRecibo(info) {

            const self = this;

            if (typeof info.recibo !== 'undefined') {
                const infoTmp = JSON.stringify(info.recibo);
                console.log(infoTmp);
                self.androidBridge.PrintRecibo(infoTmp);
            }

        },
        printVoucherPdf(item) {
            const self =this;
            API.send('POST', 'print/voucher/' + item.id, null,
                function (response) {
                    store.dispatch('coreHideLoading');
                    window.open(CONFIG.apiUrl+"/download/docs/" + response.data);
                },
                function () {
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                });
            //this.androidBridge.PrintVoucher(this.infoVoucher);
        },
        printInvoicePdf(item) {
            const self =this;
            API.send('POST', 'print/factura/' + item.id, null,
                function (response) {
                    store.dispatch('coreHideLoading');
                    window.open(CONFIG.apiUrl+"/download/docs/" + response.data);
                },
                function () {
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                });
            //this.androidBridge.PrintVoucher(this.infoVoucher);
        },
        printInvoiceTwoPdf(item) {
            const self =this;
            API.send('POST', 'print/facturados/' + item.id, null,
                function (response) {
                    store.dispatch('coreHideLoading');
                    window.open(CONFIG.apiUrl+"/download/docs/" + response.data);
                },
                function () {
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                });
            //this.androidBridge.PrintVoucher(this.infoVoucher);
        },
        printReciboPdf(item) {
            const self =this;
            API.send('POST', 'print/recibo/' + item.id, null,
                function (response) {
                    store.dispatch('coreHideLoading');
                    window.open(CONFIG.apiUrl+"/download/docs/" + response.data);
                },
                function () {
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                });
            //this.androidBridge.PrintVoucher(this.infoVoucher);
        },
        anularPos(item) {
            const self = this;

            if (item.type === 'TAR') {
                this.anulando = item;
                let montoVisa = (parseFloat(item.monto) % 1 !== 0) ? item.monto.toString().replace(".", "") : item.monto+"00";
                this.androidBridge.VisanetPayAppAnular(montoVisa, item.auditNumber);
            }

            /*API.send('POST', 'cobros/anular', {
                    id: item.id
                },
                function (response) {
                    console.log(response);
                    store.dispatch('coreHideLoading');

                    if (typeof response.status !== 'undefined') {
                        alert(response.msg);
                    }
                    else {
                        alert('Error al revertir, por favor intente de nuevo');
                    }
                    self.getTrans();
                },
                function () {
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                });*/
        },
        revertirEpay(item) {
            const self = this;
            API.send('POST', 'cobros/anular', {
                    id: item.id
                },
                function (response) {
                    console.log(response);
                    store.dispatch('coreHideLoading');

                    if (typeof response.status !== 'undefined') {
                        alert(response.msg);
                    }
                    else {
                        alert('Error al revertir, por favor intente de nuevo');
                    }
                    self.getTrans();
                },
                function () {
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                });
        },
    },
};
</script>
